import React from "react";
import InterestValue from "../interests/interest-value";
import { formatRange } from "./formatRange";
import OpportunityCard from "./opportunity-card";

class ContentSwapOpportunityCard extends React.Component {
  render() {
    let {
      opportunity,
      brand,
      brand: { obscure },
      isBrand,
      action,
      showActions,
      hideBar,
      editOpportunity,
      shareOpportunity,
      deleteOpportunity,
    } = this.props;

    return (
      <OpportunityCard
        opportunity={opportunity}
        brand={brand}
        action={action}
        editOpportunity={editOpportunity}
        deleteOpportunity={deleteOpportunity}
        shareOpportunity={shareOpportunity}
        isBrand={isBrand}
        showActions={showActions}
        hideBar={hideBar}
      >
        <InterestValue
          title="Swaps/Month"
          value={formatRange(opportunity.min_swaps_per_month, opportunity.max_swaps_per_month)}
          marginRight="24px"
          marginBottom="0px"
          obscure={obscure}
        />
        <InterestValue
          title="Avg Clicks/Article"
          value={opportunity.average_clicks}
          marginBottom="0px"
          obscure={obscure}
        />
      </OpportunityCard>
    );
  }
}

export default ContentSwapOpportunityCard;
